import { CTAPIConfiguration } from './utils/configuration';
import { RequestHelper } from './utils/request';
import { SettingsRestInterface } from './interfaces/_settings.rest';
import { Settings } from '../models/interfaces/_settings.model';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class SettingsRest implements SettingsRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request for settings.
     */
    getSettings(nDivID: number, sEnvCode): Observable<Settings> {
        return this.requestHelper.request({ data: { nDivID, sEnvCode } }, this.configuration.settings.get,
            this.configuration.httpClient).pipe(
                map((response) => {
                    return response.result;
                })
            );
    }

}
